"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRow = void 0;
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
function TableRow({ children, testId, className }) {
    return (react_1.default.createElement("tr", { className: (0, clsx_1.default)(className), "data-testid": testId }, children));
}
exports.TableRow = TableRow;
//# sourceMappingURL=TableRow.js.map